'use client';

import React from 'react';
import { usePathname, useRouter } from 'next/navigation';
import {
  CascadeOption,
  Option,
} from '@/components/form/cascade-select/CascadeSelect';
import { NATION_WIDE } from '@/constants/city';
import { JOB_RANKING_PAGE_ROUTER_PATH } from '@/constants/router-path';
import {
  RANK_TOP_SALARY_PAGE_ROUTER_PATH,
  RANK_TOP_POST_PAGE_ROUTER_PATH,
} from '@/constants/router-path';
import CitySearch from '@/components/seo/search-area/CitySearch';
import { JobTitleRankType } from '@/types/job-ranking';

type Props = {
  options: CascadeOption[];
  location: JobTitleRankType['location'];
  filterId: string;
};

export default function RankingCitySearch(props: Props) {
  const { options, location, filterId } = props;
  const router = useRouter();
  const pathName = usePathname();

  const handleSearch = (value: Option) => {
    const { id, pinyin } = value;
    if (!pinyin || id === location?.id) return;
    const endPath = pathName?.endsWith(RANK_TOP_SALARY_PAGE_ROUTER_PATH)
      ? RANK_TOP_SALARY_PAGE_ROUTER_PATH
      : pathName?.endsWith(RANK_TOP_POST_PAGE_ROUTER_PATH)
        ? RANK_TOP_POST_PAGE_ROUTER_PATH
        : '/';
    router.push(
      `${JOB_RANKING_PAGE_ROUTER_PATH}${id === NATION_WIDE.id ? filterId : `${pinyin}_${filterId}`}${endPath}`,
    );
  };

  return (
    <CitySearch
      cityValue={location || NATION_WIDE}
      existCities={[NATION_WIDE, ...options]}
      onSearch={handleSearch}
      borderColor="border border-web-blue-500"
    />
  );
}
